/** Helper to create multiple routes that share the same redirect logic */
export const createRoutes = (paths, options = {}) =>
  paths.map(path => ({
    path,
    ...options,
  }));
